import { type FunctionComponent } from 'react';
import { ClickableIcon, IconVerticalMenu, Menu, type MenuProps, type MenuSize } from '@direct-frontend/components';
import { type OpenApiSchemaProductVariant } from '#shared/api/schema';
import { type ProductVariantMenuOptions, useProductVariantMenu } from '../../hooks/useProductVariantMenu';
import { productVariantMenuTestIds } from './testids';

export interface ProductVariantMenuProps
    extends Omit<MenuProps<string>, 'size' | 'items' | 'trigger' | 'data-testid'>,
        ProductVariantMenuOptions {
    size?: MenuSize;
    variant: OpenApiSchemaProductVariant | undefined;
}

export const ProductVariantMenu: FunctionComponent<ProductVariantMenuProps> = ({
    'aria-label': ariaLabel = 'Контекстное меню варианта',
    size = 'm',
    placement = 'bottom-start',
    variant,
    withEditLink,
    onStatusChanged,
    onDeleted,
    ...props
}) => {
    const { items, renderConfirmModal } = useProductVariantMenu(variant, { onDeleted, onStatusChanged, withEditLink });

    return (
        <>
            <Menu
                {...props}
                aria-label={ariaLabel}
                placement={placement}
                size={size}
                items={items}
                trigger={
                    <ClickableIcon
                        data-testid={productVariantMenuTestIds.open}
                        isDisabled={!variant}
                        role="supplementary"
                    >
                        <IconVerticalMenu size="20" />
                    </ClickableIcon>
                }
            />
            {renderConfirmModal()}
        </>
    );
};
